import React, { useEffect } from "react";
import "./index.css";
import dayjs from "dayjs";
import { useProjectState } from "../../../context/stateContext";
import { useLocation } from "react-router-dom";
const PageHeader = ({ text, date }) => {
  const { startDate, endDate } = useProjectState();
  const location = useLocation();
  const { pathname } = location;

  //dynamic website title
  useEffect(() => {
    if (pathname === "/dashboard") {
      document.title = `Дашборд - TouchSale Portal`;
    } else {
      document.title = `${text.split("(")[0]} - TouchSale Portal`;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text]);

  const getDaysDiff = () => {
    const daysDiff =
      Math.abs(
        dayjs(endDate, { format: "YYYY-MM-DDTHH:mm:ss.SSS" }).diff(
          dayjs(startDate, { format: "YYYY-MM-DDTHH:mm:ss.SSS" }),
          "days"
        )
      ) + 1;

    if (daysDiff === 1) {
      return `(${daysDiff} ден)`;
    } else if (daysDiff > 1) {
      return `(${daysDiff} дни)`;
    }
  };

  if (date) {
    text = text + " " + getDaysDiff();
  }

  return <div className="page-header-title">{text}</div>;
};

export default PageHeader;
